var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, Utils, LogLevel } from './_default-imports';
import { PacemElement } from './types';
import { CustomElementUtils } from '../../utils-customelement';
import { CustomTypedEvent } from '../../events';
//namespace Pacem.Components {
export class PacemItemElement extends PacemElement {
    get container() {
        return this._container;
    }
    /** @overridable */
    findContainer() {
        return CustomElementUtils.findAncestor(this, n => n instanceof PacemItemsContainerElement);
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const container = this._container = this.findContainer();
        if (!Utils.isNull(container)) {
            container.register(this);
        }
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._container)) {
            this._container.unregister(this);
        }
        super.disconnectedCallback();
    }
}
export function isItemsContainer(object) {
    return 'items' in object
        && (Utils.isNull(object.items) || Utils.isArray(object.items))
        && typeof object.register === 'function'
        && typeof object.unregister === 'function';
}
export const ItemRegisterEventName = "itemregister";
export const ItemUnregisterEventName = "itemunregister";
export class ItemRegisterEvent extends CustomTypedEvent {
    constructor(item, eventInit) {
        super(ItemRegisterEventName, item, eventInit);
    }
}
export class ItemUnregisterEvent extends CustomTypedEvent {
    constructor(item, eventInit) {
        super(ItemUnregisterEventName, item, eventInit);
    }
}
class ItemsContainerRegistrar {
    constructor(_container) {
        this._container = _container;
        if (_container == null || !(_container instanceof PacemItemsContainerElement || _container instanceof PacemCrossItemsContainerElement)) {
            throw `Must provide a valid itemscontainer.`;
        }
    }
    register(item) {
        const container = this._container;
        var retval = false;
        if (!container.validate(item)) {
            container.logger && container.logger.log(LogLevel.Debug, `${(item && item.localName)} element couldn't be registered in a ${container.localName} element.`);
        }
        else {
            if (Utils.isNull(container.items)) {
                container.items = [item];
                retval = true;
            }
            else if (container.items.indexOf(item) === -1) {
                container.items.push(item);
                retval = true;
            }
        }
        if (retval) {
            container.dispatchEvent(new ItemRegisterEvent(item));
        }
        return retval;
    }
    unregister(item) {
        const container = this._container;
        if (!Utils.isNull(container.items)) {
            const ndx = container.items.indexOf(item);
            if (ndx >= 0) {
                let item = container.items.splice(ndx, 1);
                container.dispatchEvent(new ItemUnregisterEvent(item[0]));
                return true;
            }
        }
        return false;
    }
}
/** Element that can be used both as ItemElement and ItemsContainer. */
export class PacemCrossItemsContainerElement extends PacemItemElement {
    constructor(role, aria) {
        super(role, aria);
        this._registrar = new ItemsContainerRegistrar(this);
    }
    /**
     * Registers a new item among the items.
     * @param item {TItem} Item to be enrolled
     */
    register(item) {
        return this._registrar.register(item);
    }
    /**
     * Removes an existing element from the items.
     * @param item {TItem} Item to be removed
     */
    unregister(item) {
        return this._registrar.unregister(item);
    }
}
__decorate([
    Watch( /* can only be databound or assigned at runtime */)
], PacemCrossItemsContainerElement.prototype, "items", void 0);
export class PacemItemsContainerElement extends PacemElement {
    constructor(role, aria) {
        super(role, aria);
        this._registrar = new ItemsContainerRegistrar(this);
    }
    /**
     * Registers a new item among the items.
     * @param item {TItem} Item to be enrolled
     */
    register(item) {
        return this._registrar.register(item);
    }
    /**
     * Removes an existing element from the items.
     * @param item {TItem} Item to be removed
     */
    unregister(item) {
        return this._registrar.unregister(item);
    }
}
__decorate([
    Watch( /* can only be databound or assigned at runtime */)
], PacemItemsContainerElement.prototype, "items", void 0);
//}
